import { memo, type ReactNode } from 'react';

const MOBILE_MAX_WIDTH_PX = 767;
const TABLET_MAX_WIDTH_PX = 1439;

export const MiniHeroImage = memo(function MiniHeroImage({
  mobileImageUrl,
  tabletImageUrl,
  desktopImageUrl,
  alt,
  className,
}: {
  mobileImageUrl?: string | null;
  tabletImageUrl?: string | null;
  desktopImageUrl?: string | null;
  alt: string;
  className?: string;
}): ReactNode {
  const fallbackSrc = desktopImageUrl ?? tabletImageUrl ?? mobileImageUrl ?? '';

  const imgClassName = ['block w-full h-auto', className].filter(Boolean).join(' ');

  return (
    <picture>
      {mobileImageUrl ? (
        <source media={`(max-width: ${MOBILE_MAX_WIDTH_PX}px)`} srcSet={mobileImageUrl} />
      ) : null}
      {tabletImageUrl ? (
        <source media={`(max-width: ${TABLET_MAX_WIDTH_PX}px)`} srcSet={tabletImageUrl} />
      ) : null}
      <img src={fallbackSrc} alt={alt} className={imgClassName} />
    </picture>
  );
});
